(function () {
  if (window.__knThumbCarouselInit) return;
  window.__knThumbCarouselInit = true;

  function init() {
    document
      .querySelectorAll('.slideshow-controls__thumbnails-container')
      .forEach(function (container) {
        var strip = container.querySelector('.slideshow-controls__thumbnails');
        if (!strip || strip.dataset.knCarouselReady) return;
        strip.dataset.knCarouselReady = '1';

        strip.style.overflowX = 'auto';
        strip.style.scrollBehavior = 'smooth';
        strip.style.scrollbarWidth = 'none';
        strip.style.msOverflowStyle = 'none';

        var wrap = document.createElement('div');
        wrap.className = 'kn-thumb-carousel';
        container.insertBefore(wrap, strip);
        wrap.appendChild(strip);

        var prevBtn = document.createElement('button');
        prevBtn.className = 'kn-thumb-arrow kn-thumb-arrow--prev';
        prevBtn.type = 'button';
        prevBtn.setAttribute('aria-label', 'Ankstesnė nuotrauka');
        prevBtn.innerHTML =
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';

        var nextBtn = document.createElement('button');
        nextBtn.className = 'kn-thumb-arrow kn-thumb-arrow--next';
        nextBtn.type = 'button';
        nextBtn.setAttribute('aria-label', 'Kita nuotrauka');
        nextBtn.innerHTML =
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';

        wrap.insertBefore(prevBtn, strip);
        wrap.appendChild(nextBtn);

        function getThumbs() {
          return strip.querySelectorAll('.slideshow-controls__thumbnail');
        }

        function getCurrentIndex(thumbs) {
          for (var i = 0; i < thumbs.length; i++) {
            if (thumbs[i].getAttribute('aria-selected') === 'true') return i;
          }
          return 0;
        }

        function scrollThumbIntoView(thumb) {
          if (!thumb) return;
          var thumbLeft = thumb.offsetLeft;
          var thumbWidth = thumb.offsetWidth;
          var stripScroll = strip.scrollLeft;
          var stripWidth = strip.clientWidth;
          var targetScroll = thumbLeft - (stripWidth / 2) + (thumbWidth / 2);
          strip.scrollTo({ left: Math.max(0, targetScroll), behavior: 'smooth' });
        }

        function goToIndex(idx) {
          var thumbs = getThumbs();
          if (!thumbs.length) return;
          if (idx < 0) idx = thumbs.length - 1; // wrap to end
          if (idx >= thumbs.length) idx = 0; // wrap to start
          var target = thumbs[idx];
          if (target) {
            target.click();
            scrollThumbIntoView(target);
          }
        }

        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var thumbs = getThumbs();
          goToIndex(getCurrentIndex(thumbs) - 1);
        });
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var thumbs = getThumbs();
          goToIndex(getCurrentIndex(thumbs) + 1);
        });

        var programmaticScroll = false;
        var userScrollMode = false;
        var userScrollResetTimer = null;

        function enterUserScrollMode() {
          userScrollMode = true;
          clearTimeout(userScrollResetTimer);
          userScrollResetTimer = setTimeout(function () { userScrollMode = false; }, 900);
        }
        strip.addEventListener('touchstart', enterUserScrollMode, { passive: true });
        strip.addEventListener('touchmove', enterUserScrollMode, { passive: true });
        strip.addEventListener('pointerdown', enterUserScrollMode, { passive: true });

        // Endless-feel wrap: detect overscroll attempts at either edge and wrap.
        var touchStartX = null;
        var touchStartedAtMax = false;
        var touchStartedAtMin = false;
        var wrapCooldownUntil = 0;
        var WRAP_OVERSCROLL_THRESHOLD = 36;

        strip.addEventListener('touchstart', function (e) {
          touchStartX = e.touches[0].clientX;
          var max = strip.scrollWidth - strip.clientWidth;
          touchStartedAtMax = max <= 4 || strip.scrollLeft >= max - 4;
          touchStartedAtMin = strip.scrollLeft <= 4;
        }, { passive: true });

        strip.addEventListener('touchmove', function (e) {
          if (touchStartX === null) return;
          if (Date.now() < wrapCooldownUntil) return;
          var dx = e.touches[0].clientX - touchStartX; // negative = swiping left (toward end)
          var thumbs = getThumbs();
          if (!thumbs.length) return;
          if (touchStartedAtMax && dx <= -WRAP_OVERSCROLL_THRESHOLD) {
            // user at the last thumb, swiping further toward the end → wrap to first
            touchStartedAtMax = false;
            touchStartX = null;
            wrapCooldownUntil = Date.now() + 700;
            programmaticScroll = true;
            strip.scrollTo({ left: 0, behavior: 'smooth' });
            setTimeout(function () { programmaticScroll = false; }, 500);
            thumbs[0].click();
          } else if (touchStartedAtMin && dx >= WRAP_OVERSCROLL_THRESHOLD) {
            // user at the first thumb, swiping further toward the start → wrap to last
            touchStartedAtMin = false;
            touchStartX = null;
            wrapCooldownUntil = Date.now() + 700;
            programmaticScroll = true;
            var max2 = strip.scrollWidth - strip.clientWidth;
            strip.scrollTo({ left: max2, behavior: 'smooth' });
            setTimeout(function () { programmaticScroll = false; }, 500);
            thumbs[thumbs.length - 1].click();
          }
        }, { passive: true });

        strip.addEventListener('touchend', function () {
          touchStartX = null;
          touchStartedAtMax = false;
          touchStartedAtMin = false;
        }, { passive: true });

        function scrollProgrammatic(target) {
          if (userScrollMode) return; // never fight an active user gesture
          programmaticScroll = true;
          var thumbLeft = target.offsetLeft;
          var thumbWidth = target.offsetWidth;
          var stripWidth = strip.clientWidth;
          var targetScroll = thumbLeft - (stripWidth / 2) + (thumbWidth / 2);
          strip.scrollTo({ left: Math.max(0, targetScroll), behavior: 'smooth' });
          setTimeout(function () { programmaticScroll = false; }, 500);
        }

        // Keep active thumb visible (only when user is NOT actively scrolling)
        var thumbObserver = new MutationObserver(function () {
          if (userScrollMode) return;
          var thumbs = getThumbs();
          for (var i = 0; i < thumbs.length; i++) {
            if (thumbs[i].getAttribute('aria-selected') === 'true') {
              scrollProgrammatic(thumbs[i]);
              break;
            }
          }
        });
        getThumbs().forEach(function (t) {
          thumbObserver.observe(t, { attributes: true, attributeFilter: ['aria-selected'] });
        });

        // When user swipes the thumb strip, advance the gallery once the scroll
        // settles. Gated behind userScrollMode so it doesn't fire on first paint.
        var scrollSettleTimer = null;
        var lastSettleClickTime = 0;
        strip.addEventListener('scroll', function () {
          if (programmaticScroll || !userScrollMode) return;
          if (scrollSettleTimer) clearTimeout(scrollSettleTimer);
          scrollSettleTimer = setTimeout(function () {
            // throttle so we don't fire on every micro-settle during a long swipe
            var now = Date.now();
            if (now - lastSettleClickTime < 240) return;
            var stripRect = strip.getBoundingClientRect();
            var stripCenter = stripRect.left + stripRect.width / 2;
            var thumbs = getThumbs();
            var closest = null;
            var minDist = Infinity;
            for (var i = 0; i < thumbs.length; i++) {
              var r = thumbs[i].getBoundingClientRect();
              var c = r.left + r.width / 2;
              var d = Math.abs(c - stripCenter);
              if (d < minDist) {
                minDist = d;
                closest = thumbs[i];
              }
            }
            if (closest && closest.getAttribute('aria-selected') !== 'true') {
              lastSettleClickTime = now;
              closest.click();
            }
          }, 200);
        }, { passive: true });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  setTimeout(init, 600);
  setTimeout(init, 1800);
})();
